import { ArchTreatementType, EArchType, wasmModule } from "@/gluelayer"

export const isRetainerArch = (toothType: EArchType) => {
  if (!wasmModule.isFinishedOpencase) return
  if (toothType === EArchType.UpArch) {
    const upArchModel = wasmModule.getArchModel(EArchType.UpArch)
    if (upArchModel) {
      const type = upArchModel.GetTreatementType()
      if (type.value === ArchTreatementType.E_RetainerArch) {
        return true
      }
      return false
    }
  }

  if (toothType === EArchType.LowArch) {
    const lowArchModel = wasmModule.getArchModel(EArchType.LowArch)

    if (lowArchModel) {
      const type = lowArchModel.GetTreatementType()
      if (type.value === ArchTreatementType.E_RetainerArch) {
        return true
      }
      return false
    }
  }
}
